import React from 'react';
import { KnowledgeBase } from '../KnowledgeBase';

const ChatbotKnowledgeBasePage: React.FC = () => {
  return <KnowledgeBase />;
};

export default ChatbotKnowledgeBasePage;
